import React, { PureComponent } from 'react';
import memoize from 'memoize-one';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import TabComponent from './tab-component';
import Programs from './programs';

const Container = styled.div`
  width: inherit;
  height: inherit;
  margin: 0 auto;
`;

const TABS = [
  {
    id: 'programs',
    label: 'Programs',
    Component: Programs,
  },
];

const getTabs = memoize(tabs =>
  tabs.map(tab => ({
    ...tab,
    link: `/curriculum-analytics/${tab.id}`,
  })),
);

export default class CurriculumAnalytics extends PureComponent {
  render() {
    const { activeTab, programId } = this.props;
    const tabs = getTabs(TABS);

    return (
      <Container>
        <TabComponent tabs={tabs} activeTab={activeTab} programId={programId} />
      </Container>
    );
  }
}
CurriculumAnalytics.propTypes = {
  activeTab: PropTypes.string,
  programId: PropTypes.string,
};

CurriculumAnalytics.defaultProps = {
  activeTab: 'programs',
  programId: null,
};
